import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=327696f2&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"
import style0 from "./Infos.vue?vue&type=style&index=0&id=327696f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327696f2",
  null
  
)

export default component.exports